(() => {
  if (window.cloudboundCartInitialized) return;
  window.cloudboundCartInitialized = true;

  let root = document.querySelector('[data-cbx-cart]');
  if (!root) return;
  let timer;
  let running = false;
  let reloadFallback = false;
  let migrationBlocked = false;
  const singleVariantId = '67907713368366';
  const legacySetCounts = { '67920029942062': 2, '67920029974830': 3 };
  const migrationStorageKey = 'cloudbound-set-migration';

  const inputs = () => Array.from(root.querySelectorAll('[data-cart-quantity]'));
  const valid = input => input.value.trim() !== '' && Number.isSafeInteger(Number(input.value)) && Number(input.value) >= 0 && input.validity.valid;
  const changes = () => inputs().filter(input => valid(input) && Number(input.value) !== Number(input.defaultValue));
  const hasLegacy = () => inputs().some(input => legacySetCounts[input.dataset.cartVariantId]);
  const propertiesSignature = properties => JSON.stringify(Object.entries(properties || {}).sort(([a], [b]) => a.localeCompare(b)));
  const inputIdentity = input => JSON.stringify([input.dataset.cartVariantId || '', input.dataset.cartSellingPlanId || '', propertiesSignature(JSON.parse(input.dataset.cartProperties || '{}'))]);
  const lineIdentity = item => JSON.stringify([String(item.variant_id || item.id), String(item.selling_plan_allocation?.selling_plan?.id || ''), propertiesSignature(item.properties)]);
  const findLine = (items, target) => {
    const exact = items.find(item => item.key === target.id);
    if (exact) return exact;
    const matches = items.filter(item => lineIdentity(item) === target.identity);
    return matches.length === 1 ? matches[0] : null;
  };
  const normalizedQuantity = () => inputs().filter(input => input.dataset.cartVariantId === singleVariantId).reduce((total, input) => total + Number(input.defaultValue), 0);
  const migrationSignature = () => JSON.stringify(inputs().filter(input => input.dataset.cartVariantId === singleVariantId || legacySetCounts[input.dataset.cartVariantId]).map(input => [input.dataset.cartKey, Number(input.defaultValue), inputIdentity(input)]).sort(([a], [b]) => a.localeCompare(b)));

  function status(message, error = false) {
    const region = root.querySelector('[data-cart-status]');
    region.textContent = message;
    region.hidden = !message;
    region.classList.toggle('cbx-cart-status-error', error);
  }

  try {
    if (sessionStorage.getItem('cloudbound-cart-recovery')) {
      sessionStorage.removeItem('cloudbound-cart-recovery');
      status(root.dataset.updateError, true);
    }
  } catch {}

  function lockCheckout(locked) {
    const checkout = root.querySelector('[name="checkout"]');
    if (checkout) checkout.disabled = locked;
  }

  function setBusy(busy) {
    root.setAttribute('aria-busy', String(busy));
    const blocked = busy || migrationBlocked || hasLegacy();
    inputs().forEach(input => { input.disabled = blocked; });
    root.querySelectorAll('[data-cart-remove]').forEach(link => link.setAttribute('aria-disabled', String(blocked)));
    lockCheckout(blocked || reloadFallback || inputs().some(input => !valid(input)) || changes().length > 0);
  }

  function replacement(html) {
    if (typeof html !== 'string') return null;
    return new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cbx-cart]');
  }

  async function refreshSection() {
    const url = new URL(window.location.href);
    url.hash = '';
    url.searchParams.set('section_id', root.dataset.sectionId);
    const response = await fetch(url.href, { credentials: 'same-origin', cache: 'no-store' });
    if (!response.ok) throw new Error(root.dataset.updateError);
    const next = replacement(await response.text());
    if (!next) throw new Error(root.dataset.updateError);
    return next;
  }

  function render(next, focusTarget) {
    root.replaceWith(next);
    root = next;
    document.querySelectorAll('.cbx-bag-button span').forEach(count => { count.textContent = root.dataset.cartCount; });
    let target = inputs().find(input => input.dataset.cartKey === focusTarget?.id);
    if (!target && focusTarget?.identity) {
      const matches = inputs().filter(input => inputIdentity(input) === focusTarget.identity);
      if (matches.length === 1) target = matches[0];
    }
    if (target) target.focus({ preventScroll: true });
    else if (focusTarget) {
      const heading = root.querySelector('h1');
      heading.tabIndex = -1;
      heading.focus({ preventScroll: true });
    }
  }

  async function normalizeLegacy() {
    let savedIntent = null;
    try { savedIntent = JSON.parse(sessionStorage.getItem(migrationStorageKey) || 'null'); } catch {}
    if (!hasLegacy() && !savedIntent) return;
    migrationBlocked = true;
    running = true;
    setBusy(true);
    status(root.dataset.migrating);
    const rows = inputs();
    const legacy = rows.filter(input => legacySetCounts[input.dataset.cartVariantId]);
    const singles = rows.filter(input => input.dataset.cartVariantId === singleVariantId);
    const expected = savedIntent?.expected ?? normalizedQuantity() + legacy.reduce((total, input) => total + Number(input.defaultValue) * legacySetCounts[input.dataset.cartVariantId], 0);
    const originalSignature = savedIntent?.original || migrationSignature();
    const isComplete = () => !hasLegacy() && normalizedQuantity() === expected;
    const complete = () => {
      try { sessionStorage.removeItem(migrationStorageKey); } catch {}
      migrationBlocked = false;
      status(root.dataset.migrated);
    };
    try {
      if (savedIntent) {
        if (isComplete() || (!hasLegacy() && normalizedQuantity() === 0)) { complete(); return; }
        if (savedIntent.original !== migrationSignature()) throw new Error(root.dataset.migrationError);
      }
      const involved = [...legacy, ...singles];
      if (involved.some(input => input.dataset.cartSellingPlanId || Object.keys(JSON.parse(input.dataset.cartProperties || '{}') || {}).length)) throw new Error(root.dataset.migrationError);
      const updates = {};
      legacy.forEach(input => { updates[input.dataset.cartKey] = 0; });
      singles.slice(1).forEach(input => { updates[input.dataset.cartKey] = 0; });
      updates[singles[0]?.dataset.cartKey || singleVariantId] = expected;
      sessionStorage.setItem(migrationStorageKey, JSON.stringify({ expected, original: originalSignature }));
      const sectionId = root.dataset.sectionId;
      const response = await fetch(root.dataset.updateUrl, {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates, sections: [sectionId], sections_url: window.location.pathname + window.location.search })
      });
      const cart = await response.json();
      if (!response.ok || !Array.isArray(cart.items)) throw new Error(root.dataset.migrationError);
      render(replacement(cart.sections?.[sectionId]) || await refreshSection());
      if (!isComplete()) throw new Error(root.dataset.migrationError);
      complete();
    } catch {
      try {
        render(await refreshSection());
        if (isComplete()) complete();
      } catch {}
      if (migrationBlocked) {
        status(root.dataset.migrationError, true);
        const reloadLink = root.querySelector('[data-cart-reload]');
        if (reloadLink) reloadLink.hidden = migrationSignature() !== originalSignature;
        const contactLink = root.querySelector('[data-cart-contact]');
        if (contactLink) contactLink.hidden = false;
      }
    } finally {
      running = false;
      setBusy(false);
    }
  }

  async function update() {
    clearTimeout(timer);
    if (running || reloadFallback || migrationBlocked || hasLegacy()) return;
    if (inputs().some(input => !valid(input))) {
      lockCheckout(true);
      status(root.dataset.invalidQuantity, true);
      return;
    }
    const pending = changes().map(input => ({ id: input.dataset.cartKey, identity: inputIdentity(input), quantity: Number(input.value) }));
    if (!pending.length) {
      lockCheckout(false);
      status('');
      return;
    }
    const focused = document.activeElement;
    const focusTarget = focused?.matches('[data-cart-quantity]') ? { id: focused.dataset.cartKey, identity: inputIdentity(focused) } : null;
    const sectionId = root.dataset.sectionId;
    running = true;
    setBusy(true);
    status(root.dataset.updating);
    let next;
    let cart;
    let adjusted = false;
    try {
      for (const change of pending) {
        const current = cart ? findLine(cart.items, change) : null;
        if (cart && !current) throw new Error(root.dataset.updateError);
        const response = await fetch(root.dataset.changeUrl, {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: current?.key || change.id, quantity: change.quantity, sections: [sectionId], sections_url: window.location.pathname + window.location.search })
        });
        const data = await response.json();
        if (!response.ok) throw new Error(typeof data.description === 'string' ? data.description : root.dataset.updateError);
        if (!Array.isArray(data.items)) throw new Error(root.dataset.updateError);
        cart = data;
        const actual = findLine(cart.items, change);
        if (actual) adjusted = adjusted || actual.quantity !== change.quantity;
        else if (change.quantity > 0 && !cart.items.some(item => lineIdentity(item) === change.identity)) adjusted = true;
        next = replacement(cart.sections?.[sectionId]);
      }
      if (!next) next = await refreshSection();
      render(next, focusTarget);
      status(adjusted ? root.dataset.quantityAdjusted : root.dataset.updated);
    } catch (error) {
      try {
        render(await refreshSection(), focusTarget);
        status(error.message || root.dataset.updateError, true);
      } catch {
        reloadFallback = true;
        status(root.dataset.updateError, true);
      }
    } finally {
      running = false;
      setBusy(false);
      if (reloadFallback) {
        try { sessionStorage.setItem('cloudbound-cart-recovery', '1'); } catch {}
        window.location.assign(window.location.href);
      }
    }
  }

  function schedule(immediate = false) {
    clearTimeout(timer);
    if (running || reloadFallback || migrationBlocked || hasLegacy()) return;
    const invalid = inputs().some(input => !valid(input));
    const dirty = changes().length > 0;
    lockCheckout(invalid || dirty);
    status(invalid ? root.dataset.invalidQuantity : dirty ? root.dataset.updating : '', invalid);
    if (!invalid && dirty) {
      if (immediate) update();
      else timer = setTimeout(update, 350);
    }
  }

  document.addEventListener('input', event => {
    if (root.contains(event.target) && event.target.matches('[data-cart-quantity]')) schedule();
  });
  document.addEventListener('change', event => {
    if (root.contains(event.target) && event.target.matches('[data-cart-quantity]')) schedule(true);
  });
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-cart-remove]');
    if (!link || !root.contains(link) || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    if (reloadFallback) return;
    event.preventDefault();
    if (running || migrationBlocked || hasLegacy()) return;
    const input = inputs().find(item => item.dataset.cartKey === link.dataset.cartKey);
    if (input) {
      input.value = '0';
      schedule(true);
    }
  });
  document.addEventListener('submit', event => {
    if (!root.contains(event.target) || !event.target.matches('.cbx-cart-form')) return;
    if (migrationBlocked || hasLegacy()) { event.preventDefault(); return; }
    if (reloadFallback) {
      if (event.submitter?.name === 'checkout') event.preventDefault();
      return;
    }
    if (running || inputs().some(input => !valid(input)) || changes().length || event.submitter?.name !== 'checkout') {
      event.preventDefault();
      schedule(true);
    }
  });
  normalizeLegacy();
})();
